function uploadWithClient(formData, groupId, axiosClient) {
    const url = `/survey/action-plan/` + groupId;
    let counter = 0;
    return axiosClient.post(url, formData)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            let ob = [];
            x.forEach(img => {
                console.log(img);
                ob.push(Object.assign({}, counter++, {name: img.fileName, url: `/action-plan/${img.id}`}));
            })
            return ob;
        });
}

function uploadWithClientWithUrl(formData, groupId, axiosClient, baseUrl) {
    const url = baseUrl + groupId;
    let counter = 0;
    return axiosClient.post(url, formData)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            let ob = [];
            x.forEach(img => {
                console.log(img);
                ob.push(Object.assign({}, counter++, {name: img.fileName, url: `/documentation/files/${img.id}`}));
            })
            return ob;
        });
}

function uploadWithClientWithUrlAndParam(formData, groupId, axiosClient, baseUrl, type) {
    const base = baseUrl + groupId;
    const url = `${base}/?type=${type}`;
    let counter = 0;
    return axiosClient.post(url, formData)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            let ob = [];
            x.forEach(img => {
                console.log(img);
                ob.push(Object.assign({}, counter++, {name: img.fileName, url: `/documentation/files/${img.id}`}));
            })
            return ob;
        });
}

export {uploadWithClient, uploadWithClientWithUrl, uploadWithClientWithUrlAndParam}
